import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from './types';

const initialState: any = {
  fetchedUsers: null,
  completeUserDetails: null,
};

const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    // set only partial state
    setFetchedUsers(state, action: PayloadAction<any[] | null>) {
      state.fetchedUsers = action.payload;
    },
    setCompleteUserDetails(state, action: PayloadAction<any | null>) {
      state.completeUserDetails = action.payload;
    },
    resetFetchedUsers(state) {
      state.fetchedUsers = null;
    },
    resetCompleteUserDetails(state) {
      state.completeUserDetails = null;
    },
    resetUserDetailsState() {
      return { ...initialState };
    },
  },
});

export const {
  setFetchedUsers,
  setCompleteUserDetails,
  resetFetchedUsers,
  resetCompleteUserDetails,
  resetUserDetailsState,
} = userDetailsSlice.actions;

export default userDetailsSlice.reducer;
